import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useCtaStyles } from './CtaSection.styles';
import { fadeUp, viewportOnce } from '../../../../styles/animations';

const CtaSection = () => {
    const { classes } = useCtaStyles();

    return (
        <Box component="section" id="contact" className={classes.section}>
            <motion.div
                className={classes.inner}
                initial="hidden"
                whileInView="visible"
                viewport={viewportOnce}
                variants={fadeUp}
            >
                <Typography variant="overline" className={classes.eyebrow}>Let's talk</Typography>
                <Typography variant="display2" component="h2" className={classes.headline}>
                    Have a complex<br />challenge?
                </Typography>
                <Button
                    variant="contained"
                    href="mailto:hello@nexora.studio"
                    sx={{ backgroundColor: 'common.white', color: 'ink.main', '&:hover': { backgroundColor: 'fog' } }}
                >
                    Start a conversation
                </Button>
            </motion.div>
        </Box>
    );
};

export default CtaSection;
